const scenePageMap = {
  home: '/',
  market: '/market',
  catering: '/catering',
  about: '/about',
  games: '/games',
  boutique: '/boutique'
};

const pageConfig = {
  // Ensure the games page loads the games scene (games.glb)
  initialScene: 'games',
  navigationMode: 'spa',
  history: true,
  scenePageMap,
  prefetchScenes: ['home', 'market', 'catering', 'about', 'games', 'boutique']
};

window.__BUBAR_PAGE__ = pageConfig;
import('../core/page.js').catch(err => console.error('Failed to load page runtime', err));
